<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="content-split"
      >
        <div class="line" />
        <h2 class="subtitle">
          {{ $t("general.label.overview") }}
        </h2>
      </div>
    </transition>
  </section>
</template>

<script>
    export default {
        name: 'Anzahl',
        props: {
            msg: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                active: false
            }
        },
        mounted() {
            this.active = true
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .content-split {
        max-width: 800px;
        width: 100%;
        padding: .9rem 0rem;
        margin: 0 auto;
        position: relative;
        text-align: center;

        .line {
            width: 100%;
            height: 1px;
            background-color: rgba(200, 200, 200, 1);
        }

        .subtitle {
            font-size: .8rem;
            text-transform: uppercase;
            width: 140px;
            position: absolute;
            top: 0.45rem;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            color: rgba(180, 180, 180, 1);
            background-color: rgba(240, 240, 240, 1);
        }
    }
</style>
